import { render } from "./matching-card-compact.vue?vue&type=template&id=22aaf924&scoped=true&ts=true"
import script from "./matching-card-compact.vue?vue&type=script&lang=ts"
export * from "./matching-card-compact.vue?vue&type=script&lang=ts"

import "./matching-card-compact.vue?vue&type=style&index=0&id=22aaf924&lang=scss&scoped=true"
import "./matching-card-compact.vue?vue&type=style&index=1&id=22aaf924&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aaf924"]])

export default __exports__